import styled, { createGlobalStyle } from 'styled-components'
import { Row } from 'antd'
import { colors } from 'web-makeup/dist/design-system/config/data/theme'

import {
  MIDLARGE_MAX_BREAKPOINT,
  MID_BREAKPOINT,
  XSMALL_BREAKPOINT,
  XXSMALL_BREAKPOINT,
} from '../../../../style'

export const Wrapper = styled.div`
  width: 100%;
  max-width: 100%;
  margin: 0 auto;
`
export const Content = styled.div`
  min-height: 100vh;
  max-width: 100%;
  padding: 0;
  margin: 0 auto;
`
export const CardWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 0 -0.75rem;

  > div {
    display: flex;
    align-items: center;
  }
`
export const SingleCardWrapper = styled.div`
  flex: 1 1 calc(33% - 1.5rem);
  max-width: calc(33% - 1.5rem);
  margin: 0 0.75rem;

  @media all and (max-width: ${XSMALL_BREAKPOINT}) {
    flex: 1 1 calc(50% - 1.5rem);
    max-width: calc(50% - 1.5rem);
  }

  @media all and (max-width: ${XXSMALL_BREAKPOINT}) {
    flex: 1 1 calc(100% - 1.5rem);
    max-width: calc(100% - 1.5rem);
  }
`
export const StyledHeaderLink = styled.div`
  font-weight: 900;
  font-size: 0.875rem;
  color: ${colors.black1};
  cursor: pointer;
  width: 10%;

  picture {
    margin-right: 0.5rem;
    vertical-align: text-bottom;
  }
`
export const HeaderText = styled.div`
  color: ${colors.black1};
  text-align: center;
  font-size: 54px;
  font-weight: 900;
  width: 110%;
`
export const GreyBackground = styled.div`
  width: 100%;
  background: ${colors.dust};
`
export const ModalTitle = styled.div`
  font-weight: 900;
  font-size: 2rem;
  line-height: 2.875rem;
  color: ${colors.black1};
  display: flex;
  align-items: center;

  @media all and (max-width: ${XSMALL_BREAKPOINT}) {
    font-size: 1.125rem;
    line-height: 28px;
  }

  img {
    margin-right: 12px;
    cursor: pointer;
  }
`
export const ModalContent = styled.div`
  font-size: 1.125rem;
  line-height: 1.75rem;
  color: ${colors.black1};
  margin-bottom: 1.5rem;

  @media all and (max-width: ${XSMALL_BREAKPOINT}) {
    display: block;
    font-size: 0.875rem;
    line-height: 1.5rem;

    input {
      width: 100%;
    }

    button {
      position: fixed;
      bottom: 20px;
      z-index: 9;
      left: 20px;
    }
  }
`
export const AntModalStyles = createGlobalStyle`
  .ant-select-dropdown-menu-item:hover {
    && {
      background: ${colors.adaptBlue};
      color: white;
    }
  }

  .ant-modal-close {
    span {
      display: none;
    }

    &::after {
      content: "Close";
      font-weight: 600;
      font-size: 0.875rem;
      line-height: 1.125rem;
      color: ${colors.black1};
      top: 1.5rem;
      right: 1.5rem;
      position: absolute;
    }
  }

  .ant-modal {
    max-width: 100%;
  }

  .ant-modal-footer.ant-modal-footer.ant-modal-footer {
    background: rgba(255, 255, 255, 0.9);
    border: 1px solid ${colors.gandalf};
    box-shadow: 0 2px 16px rgba(0, 0, 0, 0.1);
    backdrop-filter: blur(16px);
    padding: 0.75rem 2.25rem;
  }

  .ant-modal-content.ant-modal-content.ant-modal-content {
    border-radius: 1.25rem;
    overflow: hidden;
  }
  
  .ant-modal-footer.ant-modal-footer.ant-modal-footer {
    border-bottom-left-radius: 1.25rem;
    border-bottom-right-radius: 1.25rem;
  }
`
export const StyledRow = styled(Row as any)`
  margin-bottom: 1.25rem;
`
export const StyledSectionTitle = styled.h2`
  font-weight: 900;
  font-size: 1.25rem;
  line-height: 2rem;
  color: ${colors.black3};
  margin: 1.5rem 0 1rem;
`
export const TeamWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 1.5rem;

  @media all and (max-width: ${MIDLARGE_MAX_BREAKPOINT}) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media all and (max-width: ${MID_BREAKPOINT}) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media all and (max-width: ${XSMALL_BREAKPOINT}) {
    grid-template-columns: 1fr;
  }

  > div {
    min-width: 0;
  }
`



// WEBPACK FOOTER //
// ./src/components/BrandDashboard/BrandDashboardTeam/BrandTeam/brand-team.style.tsx